
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { Profile } from "@/integrations/supabase/types";
import { OptimizedAvatar } from "../OptimizedAvatar";

interface AvatarDisplayProps {
  avatarUrl: string | null;
  profile: Profile | null;
  onRemove: () => Promise<void>;
  isUploading: boolean;
}

export function AvatarDisplay({
  avatarUrl,
  profile,
  onRemove,
  isUploading
}: AvatarDisplayProps) {
  return (
    <div className="relative">
      <OptimizedAvatar
        src={avatarUrl}
        userName={profile?.full_name || profile?.username}
        userEmail={profile?.email}
        alt={`Avatar de ${profile?.full_name || profile?.username || 'usuário'}`}
        size="xl" // Using xl size which is w-12 h-12, but we'll override with custom classes
        className="h-24 w-24"
        fallback={profile?.full_name?.charAt(0)?.toUpperCase() ||
                 profile?.username?.charAt(0)?.toUpperCase() ||
                 'U'}
        showLoading={true}
      />
      {avatarUrl && (
        <Button
          variant="destructive"
          size="icon"
          className="absolute -top-2 -right-2 h-6 w-6 rounded-full"
          onClick={onRemove}
          disabled={isUploading}
        >
          <X className="h-3 w-3" />
        </Button>
      )}
    </div>
  );
}
